// common/ThemeToggle.js
import React, { useRef } from "react";
import { IconButton, Tooltip, Box, useTheme, alpha } from "@mui/material";
import {
  LightMode as SunIcon,
  DarkMode as MoonIcon,
} from "@mui/icons-material";
import { ThemeDataContext } from "../context/ThemeContext";

const ThemeToggle = ({ size = "small", showLabel = false }) => {
  const theme = useTheme();
  const { mode, toggleColorMode } = React.useContext(ThemeDataContext);
  const isDark = mode === "dark";
  const btnRef = useRef(null);

  const handleClick = () => {
    const rect = btnRef.current?.getBoundingClientRect();
    const x = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
    const y = rect ? rect.top + rect.height / 2 : window.innerHeight / 2;
    toggleColorMode(x, y);
  };

  return (
    <Tooltip
      title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
      arrow
    >
      <IconButton
        ref={btnRef}
        onClick={handleClick}
        size={size}
        sx={{
          position: "relative",
          width: size === "small" ? 34 : 40,
          height: size === "small" ? 34 : 40,
          borderRadius: "10px",
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          overflow: "hidden",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            transform: "scale(1.05)",
          },
        }}
      >
        {/* Animated icon swap */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition:
              "transform 0.4s cubic-bezier(0.34,1.56,0.64,1), opacity 0.3s ease",
            transform: isDark
              ? "translateY(0) rotate(0deg)"
              : "translateY(-100%) rotate(-90deg)",
            opacity: isDark ? 1 : 0,
          }}
        >
          <MoonIcon sx={{ fontSize: size === "small" ? 17 : 20 }} />
        </Box>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition:
              "transform 0.4s cubic-bezier(0.34,1.56,0.64,1), opacity 0.3s ease",
            transform: isDark
              ? "translateY(100%) rotate(90deg)"
              : "translateY(0) rotate(0deg)",
            opacity: isDark ? 0 : 1,
          }}
        >
          <SunIcon sx={{ fontSize: size === "small" ? 17 : 20 }} />
        </Box>
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
